import { withRouter } from "react-router";
import React from "react";
import CustomStepper from "./CustomStepper";
import Slider from "@material-ui/core/Slider";
import TextField from "@material-ui/core/TextField";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import Skeleton from "@material-ui/lab/Skeleton";
import Card from "@material-ui/core/Card";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import HelpIcon from "@material-ui/icons/Help";
import IconButton from "@material-ui/core/IconButton";

import S3 from "aws-s3";
import clubsList from "./clubs.json";
import badwords from "./badwords.json";

class Layout extends React.Component {
  constructor(props) {
    super(props);
    let initX = 0;
    let initY = 0;
    let initZoom = 1;
    if (props.match.params.id === "1") {
      initX = -900;
      initY = 400;
      initZoom = 1.2;
    }
    if (props.match.params.id === "2") {
      initX = 0;
      initY = 0;
    }
    if (props.match.params.id === "3") {
      initX = -700;
      initY = 100;
      initZoom = 1;
    }
    this.state = {
      //Window stuff
      containerHeight: 0,
      containerWidth: 0,
      scaleLayout: 1,
      loading: true,
      //Layout stuff
      layoutIndex: props.match.params.id,
      uploadedImg: "",
      uploadedImgCropped: "",
      uploadStatus: "",
      uploadStatusType: "info",
      uploadStatusOpen: false,
      name: "Enter Name",
      playerCutout: "true",
      bnw: false,
      bnwExtraLabel: "Background",
      club: "select_club",
      currentStep: 0,
      theme: "black",
      imgProperties: {
        x: initX,
        y: initY,
        offsetX: 0,
        offsetY: 0,
        scale: 1,
      },
      flickerAnimation: "",
      downloadStatus: "",
      dialogOpen: false,
    };
    this.layouts = {
      1: {
        path: "vert",
        width: 1080,
        height: 1920,
        textX: 20,
        textY: 1368,
        textSize: 72,
        assetsY: 0,
        assetsTopY: 1400,
        textWidth: 1024,
      },
      2: {
        path: "hz",
        width: 1920,
        height: 1080,
        textX: 375,
        textY: 808,
        textSize: 100,
        assetsY: 0,
        assetsTopY: 820,
        textWidth: 1500,
      },
      3: {
        path: "sq",
        width: 1080,
        height: 1080,
        textX: 8,
        textY: 545,
        textSize: 72,
        assetsY: 0,
        assetsTopY: 580,
        textWidth: 1024,
      },
    };
    this.zoom = initZoom;
    this.mainCanvas = document.getElementById("mainCanvas");
    this.imageFiles = [];
    this.clubDirty = false;
    this.themeDirty = false;
    this.downloadPic = false;

    this.baseUrl = "https://tig-mls-demo.s3.us-west-2.amazonaws.com/layouts/";
    this.path = this.layouts[this.state.layoutIndex].path;
    this.updateDim = this.updateDimensions.bind(this);
    this.painters = {};
    this.componentUnmounted = false;

    this.newUploadBg = "";
    this.newUploadTop = "";
    this.newUpload = false;
    this.newUploadWidth = 0;
    this.newUploadHeight = 0;
    this.newUploadZoom = 1;
    const clubs = clubsList.map((value, index) => {
      return (
        <option key={index + "_value"} value={value.value}>
          {value.name}
        </option>
      );
    });
    this.clubs = clubs;
    this.newImageRendered = false;
    this.change = true;

    this.regex = new RegExp("\\b(" + badwords.badWords.join("|") + ")\\b", "i");
  }

  componentDidMount() {
    //Re-sizer
    this.updateDim();
    window.addEventListener("resize", this.updateDim);
    const loadBold = fetch(
      "https://tig-mls-demo.s3.us-west-2.amazonaws.com/DINNextLTPro-Heavy.ttf"
    ).then((response) => response.arrayBuffer());
    let picBg = fetch(
      "https://tig-mls-app-upload.s3.us-west-2.amazonaws.com/bg_3.png"
    )
      .then((response) => response.arrayBuffer())
      .then((buffer) => {
        this.imageFiles[0] = buffer;
      });
    let picTop = fetch(
      "https://tig-mls-app-upload.s3.us-west-2.amazonaws.com/top.png"
    )
      .then((response) => response.arrayBuffer())
      .then((buffer) => {
        this.imageFiles[1] = buffer;
      });

    /*
     * Layers
     */
    let xImg = fetch(this.baseUrl + this.path + "/visuals/x.png")
      .then((response) => response.arrayBuffer())
      .then((buffer) => {
        this.imageFiles[2] = buffer;
      });
    let xOverlayImg = fetch(this.baseUrl + this.path + "/visuals/x_overlay.png")
      .then((response) => response.arrayBuffer())
      .then((buffer) => {
        this.imageFiles[3] = buffer;
      });
    let starPattern = fetch(
      this.baseUrl +
        this.path +
        "/visuals/star_pattern_" +
        this.state.theme +
        ".png"
    )
      .then((response) => response.arrayBuffer())
      .then((buffer) => {
        this.imageFiles[4] = buffer;
      });
    let nameBanner = fetch(
      this.baseUrl +
        this.path +
        "/visuals/name_banner_" +
        this.state.theme +
        ".png"
    )
      .then((response) => response.arrayBuffer())
      .then((buffer) => {
        this.imageFiles[5] = buffer;
      });
    let clubBanner = fetch(
      this.baseUrl +
        this.path +
        "/visuals/club_banners_" +
        this.state.theme +
        "/select_club.png"
    )
      .then((response) => response.arrayBuffer())
      .then((buffer) => {
        this.imageFiles[6] = buffer;
      });
    //
    let mlsLogo = fetch(
      this.baseUrl + this.path + "/visuals/mls_primary_logo.png"
    )
      .then((response) => response.arrayBuffer())
      .then((buffer) => {
        this.imageFiles[7] = buffer;
      });
    let texture1 = fetch(
      this.baseUrl + this.path + "/visuals/textures/texturefabrik_lighten.png"
    )
      .then((response) => response.arrayBuffer())
      .then((buffer) => {
        this.imageFiles[8] = buffer;
      });
    let texture2 = fetch(
      this.baseUrl + this.path + "/visuals/textures/texturefabrik_multiply.png"
    )
      .then((response) => response.arrayBuffer())
      .then((buffer) => {
        this.imageFiles[9] = buffer;
      });
    let texture3 = fetch(
      this.baseUrl + this.path + "/visuals/textures/overlaytexture_multiply.png"
    )
      .then((response) => response.arrayBuffer())
      .then((buffer) => {
        this.imageFiles[10] = buffer;
      });

    Promise.all([
      loadBold,
      picBg,
      picTop,
      xImg,
      xOverlayImg,
      starPattern,
      nameBanner,
      clubBanner,
      mlsLogo,
      texture1,
      texture2,
      texture3,
    ]).then((results) => {
      this.setState({ loading: false }, () => {
        this.preventScrolling();
      });
      this.renderGraphic(this.props.canvasKit, results[0]);
    });
  }

  componentWillUnmount() {
    this.componentUnmounted = true;
    window.removeEventListener("resize", this.updateDim);
    window.cancelAnimationFrame(1);
    Object.keys(this.painters).map((value, index) => {
      return this.painters[value].delete();
    });
  }

  rerender() {
    this.change = true;
  }
  renderGraphic(CanvasKit, fontData) {
    if (!fontData) {
      return;
    }
    const surface = CanvasKit.MakeCanvasSurface("mainCanvas");
    if (!surface) {
      return;
    }
    const canvas = surface.getCanvas();
    /*
     *
     */
    const width = this.layouts[this.state.layoutIndex].width;
    const height = this.layouts[this.state.layoutIndex].height;
    const layoutIndex = this.state.layoutIndex;

    /*
     * Text
     */

    const fontMgr = CanvasKit.SkFontMgr.FromData([fontData]);

    /*
     * Load them all
     */
    const img0 = this.imageFiles[0];
    canvas._img0 = CanvasKit.MakeImageFromEncoded(img0);
    const img1 = this.imageFiles[1];
    canvas._img1 = CanvasKit.MakeImageFromEncoded(img1);
    const img2 = this.imageFiles[2];
    canvas._img2 = CanvasKit.MakeImageFromEncoded(img2);
    const img3 = this.imageFiles[3];
    canvas._img3 = CanvasKit.MakeImageFromEncoded(img3);
    const img4 = this.imageFiles[4];
    canvas._img4 = CanvasKit.MakeImageFromEncoded(img4);
    const img5 = this.imageFiles[5];
    canvas._img5 = CanvasKit.MakeImageFromEncoded(img5);
    const img6 = this.imageFiles[6];
    canvas._img6 = CanvasKit.MakeImageFromEncoded(img6);
    const img7 = this.imageFiles[7];
    canvas._img7 = CanvasKit.MakeImageFromEncoded(img7);
    const img8 = this.imageFiles[8];
    canvas._img8 = CanvasKit.MakeImageFromEncoded(img8);
    const img9 = this.imageFiles[9];
    canvas._img9 = CanvasKit.MakeImageFromEncoded(img9);
    const img10 = this.imageFiles[10];
    canvas._img10 = CanvasKit.MakeImageFromEncoded(img10);

    let x = this.state.imgProperties.x;
    let y = this.state.imgProperties.y;
    let imageWidth = canvas._img0.width();
    let imageHeight = canvas._img0.height();
    let srcRect = CanvasKit.XYWHRect(0, 0, imageWidth, imageHeight);

    this.painters["paintImg"] = new CanvasKit.SkPaint();
    this.painters["paintImg"].setFilterQuality(CanvasKit.FilterQuality.High);
    const bnwFilter = CanvasKit.SkColorFilter.MakeMatrix([
      0.2126,
      0.7152,
      0.0722,
      0,
      0,
      0.2126,
      0.7152,
      0.0722,
      0,
      0,
      0.2126,
      0.7152,
      0.0722,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
    ]);
    this.painters["paintImg"].setColorFilter(bnwFilter);

    this.painters["paintImgX"] = new CanvasKit.SkPaint();
    this.painters["paintImgX"].setBlendMode(CanvasKit.BlendMode.DstATop);

    this.painters["paintColorBg"] = new CanvasKit.SkPaint();
    this.painters["paintColorBg"].setColor(CanvasKit.WHITE);
    this.painters["paintColorBg"].setBlendMode(CanvasKit.BlendMode.DstATop);
    const colorBg = CanvasKit.LTRBRect(0, 0, width, height);

    this.painters["paintImgXOverlay"] = new CanvasKit.SkPaint();
    this.painters["paintImgXOverlay"].setBlendMode(CanvasKit.BlendMode.Overlay);

    this.painters["paintImg2"] = new CanvasKit.SkPaint();
    this.painters["paintImg2"].setFilterQuality(CanvasKit.FilterQuality.High);
    //rgb(45 249 255)
    const solidFilter = CanvasKit.SkColorFilter.MakeMatrix([
      0, //r
      0,
      0,
      0,
      45 / 255,
      0, //g
      0,
      0,
      0,
      249 / 255,
      0, //b
      0,
      0,
      0,
      255 / 255,
      45 / 255, //4
      249 / 255,
      255 / 255,
      1,
      0,
    ]);
    this.painters["paintImg2"].setColorFilter(solidFilter);

    this.painters["paintLighten"] = new CanvasKit.SkPaint();
    this.painters["paintLighten"].setBlendMode(CanvasKit.BlendMode.Lighten);

    this.painters["paintMultiply"] = new CanvasKit.SkPaint();
    this.painters["paintMultiply"].setBlendMode(CanvasKit.BlendMode.Multiply);

    function drawFrame() {
      if (this.componentUnmounted) {
        return;
      }
      if (this.change) {
        if (this.newUpload) {
          updateImageUpload(
            0,
            this.newUploadBg,
            null,
            this.rerender.bind(this)
          );
          updateImageUpload(
            1,
            this.newUploadTop,
            () => {
              this.newImageRendered = true;
            },
            this.rerender.bind(this)
          );

          imageWidth = this.newUploadWidth;
          imageHeight = this.newUploadHeight;
          srcRect = CanvasKit.XYWHRect(0, 0, imageWidth, imageHeight);
          this.newUpload = false;
          this.zoom = this.newUploadZoom;
          x = 0;
          y = 0;
        }
        if (this.newImageRendered) {
          this.setState(
            {
              uploadStatus: "Image is ready. Select your theme and click next.",
              uploadStatusType: "success",
            },
            () => {
              setTimeout(() => {
                this.setState({
                  uploadStatus: "",
                  uploadStatusType: "info",
                  uploadStatusOpen: false,
                });
              }, 5000);
            }
          );
          this.newImageRendered = false;
        }
        canvas.clear(CanvasKit.WHITE);

        if (this.themeDirty) {
          updateTheme(
            this.baseUrl,
            this.path,
            this.state.theme,
            this.state.club,
            this.rerender.bind(this)
          );
          this.themeDirty = false;
        }
        /*
         * Image Upload Settings
         */
        const destRect = CanvasKit.XYWHRect(
          x,
          y,
          imageWidth * this.zoom,
          imageHeight * this.zoom
        );
        const destRect2 = CanvasKit.XYWHRect(
          x + 10,
          y + 5,
          imageWidth * this.zoom,
          imageHeight * this.zoom
        );

        canvas.drawImage(canvas._img2, 0, 0, null); //x.png
        if (this.state.bnw) {
          canvas.drawImageRect(
            canvas._img0,
            srcRect,
            destRect,
            this.painters["paintImg"],
            false
          );
        } else {
          canvas.drawImageRect(canvas._img0, srcRect, destRect, null, false);
        }
        canvas.drawImage(canvas._img2, 0, 0, this.painters["paintImgX"]); //x.png

        if (this.state.theme === "black") {
          this.painters["paintColorBg"].setColor(CanvasKit.BLACK);
          canvas.drawRect(colorBg, this.painters["paintColorBg"]); //BG
        } else {
          this.painters["paintColorBg"].setColor(CanvasKit.WHITE);
          canvas.drawRect(colorBg, this.painters["paintColorBg"]); //BG
        }
        canvas.drawImage(canvas._img3, 0, 0, this.painters["paintImgXOverlay"]); //x_overlay.png
        canvas.drawImage(canvas._img3, 0, 0, this.painters["paintImgXOverlay"]); //x_overlay.png

        if (this.state.playerCutout === "true") {
          this.setState({
            imgProperties: {
              x: 0,
              y: 0,
              ...this.state.imgProperties,
            },
          });
          canvas.drawImageRect(
            canvas._img1,
            srcRect,
            destRect2,
            this.painters["paintImg2"],
            false
          );
          canvas.drawImageRect(canvas._img1, srcRect, destRect, null, false);
        }

        canvas.drawImage(canvas._img4, 0, 0, null); //star_pattern.png
        if (this.state.name !== "") {
          canvas.drawImage(
            canvas._img5,
            0,
            this.layouts[layoutIndex].assetsY,
            null
          ); //Name banner
        }
        if (this.state.club !== "none") {
          canvas.drawImage(
            canvas._img6,
            0,
            this.layouts[layoutIndex].assetsY,
            null
          ); //Club banner
          if (this.clubDirty) {
            updateImage(
              6,
              this.baseUrl,
              this.path + "/visuals/club_banners_" + this.state.theme + "/",
              this.state.club,
              this.rerender.bind(this)
            );
            this.clubDirty = false;
          }
        }

        /*
         * Text
         */
        if (this.state.name !== "") {
          let color;
          if (this.state.theme === "black") {
            color = CanvasKit.BLACK;
          } else {
            color = CanvasKit.Color(45, 249, 255, 1.0);
          }
          const text = this.state.name.toUpperCase();
          const paraStyle = new CanvasKit.ParagraphStyle({
            textStyle: {
              color: color,
              fontFamilies: ["DIN Next LT Pro"],
              fontSize: this.layouts[layoutIndex].textSize,
              maxLines: 0,
            },
            textAlign: CanvasKit.TextAlign.Center,
            heightMultiplier: 1,
          });
          const builder = CanvasKit.ParagraphBuilder.Make(paraStyle, fontMgr);
          builder.addText(text);
          const paragraph = builder.build();
          paragraph.layout(this.layouts[layoutIndex].textWidth);
          canvas.drawParagraph(
            paragraph,
            this.layouts[layoutIndex].textX,
            this.layouts[layoutIndex].assetsY + this.layouts[layoutIndex].textY
          );

          builder.delete();
          paragraph.delete();
        }

        canvas.drawImage(canvas._img7, 0, 0, null); //MLS Logo

        canvas.drawImage(canvas._img8, 0, 0, this.painters["paintLighten"]); //Texture 1
        canvas.drawImage(canvas._img9, 0, 0, this.painters["paintMultiply"]); //Texture 2
        canvas.drawImage(canvas._img10, 0, 0, this.painters["paintMultiply"]); //Texture 3

        surface.flush();
        if (this.downloadPic) {
          this.downloadPNG();
        } else {
          this.change = false;
        }
      }

      surface.requestAnimationFrame(drawFrame.bind(this));
    }

    function updateImage(index, baseUrl, path, filename, rerender) {
      fetch(baseUrl + path + filename + ".png")
        .then((response) => response.arrayBuffer())
        .then((buffer) => {
          canvas["_img" + index] = CanvasKit.MakeImageFromEncoded(buffer);
          rerender();
        });
    }
    function updateImageUpload(index, url, imageRendered, rerender) {
      fetch(url)
        .then((response) => response.arrayBuffer())
        .then((buffer) => {
          canvas["_img" + index] = CanvasKit.MakeImageFromEncoded(buffer);
          if (index === 1) {
            imageRendered();
          }
          rerender();
        });
    }

    function updateTheme(baseUrl, path, theme, club, rerender) {
      updateImage(
        4,
        baseUrl,
        path + "/visuals/",
        "star_pattern_" + theme,
        rerender
      );
      updateImage(
        5,
        baseUrl,
        path + "/visuals/",
        "name_banner_" + theme,
        rerender
      );
      if (club !== "none") {
        updateImage(
          6,
          baseUrl,
          path + "/visuals/club_banners_" + theme + "/",
          club,
          rerender
        );
      }
    }
    /*
     * Drag Function
     */
    let hold = false;
    let interact = (e) => {
      e.preventDefault();
      let type = e.type;
      if (
        type === "lostpointercapture" ||
        type === "pointerup" ||
        type === "touchend" ||
        !e.pressure
      ) {
        if (this.state.currentStep === 1) {
          this.setState({
            imgProperties: { ...this.state.imgProperties, x: x, y: y },
          });
        }
        hold = false;
        return;
      }
      if (hold) {
        if (this.state.currentStep === 1) {
          x = e.offsetX - this.state.imgProperties.offsetX;
          y = e.offsetY - this.state.imgProperties.offsetY;
        }
        if (this.state.currentStep === 2) {
          this.layouts[layoutIndex].assetsY =
            e.offsetY - this.layouts[layoutIndex].assetsTopY;
        }
      } else {
        if (this.state.currentStep === 1) {
          this.setState({
            imgProperties: {
              ...this.state.imgProperties,
              offsetX: e.offsetX - this.state.imgProperties.x,
              offsetY: e.offsetY - this.state.imgProperties.y,
            },
          });
        }
        if (this.state.currentStep === 2) {
          this.layouts[layoutIndex].assetsY =
            e.offsetY - this.layouts[layoutIndex].assetsTopY;
        }
      }
      hold = true;
      this.rerender();
    };
    document
      .getElementById("mainCanvas")
      .addEventListener("pointermove", interact);
    document
      .getElementById("mainCanvas")
      .addEventListener("pointerdown", interact);
    document
      .getElementById("mainCanvas")
      .addEventListener("touchend", interact);

    surface.requestAnimationFrame(drawFrame.bind(this));
  }

  downloadPNG() {
    const canvas = document.getElementById("mainCanvas");
    let element = document.createElement("a");
    element.setAttribute("href", canvas.toDataURL("image/png", 1.0));
    element.setAttribute("download", "image.png");
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    this.downloadPic = false;
    this.setState(
      {
        uploadStatusType: "success",
        uploadStatus:
          "Success! Click on the ? for info on where to find your image",
      },
      () => {
        setTimeout(() => {
          this.setState({
            uploadStatusOpen: false,
            uploadStatusType: "info",
            uploadStatus: "",
          });
        }, 10000);
      }
    );
  }

  handleNext() {
    if (this.state.currentStep === 3) {
      this.props.history.push("/");
    }
    if (this.state.currentStep + 1 === 2 || this.state.currentStep + 1 === 1) {
      this.setState({
        currentStep: this.state.currentStep + 1,
        flickerAnimation: "animate-flicker",
      });
    } else {
      this.setState({
        currentStep: this.state.currentStep + 1,
        flickerAnimation: "",
      });
    }
  }

  handleBack() {
    if (this.state.currentStep === 0) {
      this.props.history.push("/");
    }
    if (this.state.currentStep - 1 === 2 || this.state.currentStep - 1 === 1) {
      this.setState({
        currentStep: this.state.currentStep - 1,
        flickerAnimation: "animate-flicker",
      });
    } else {
      this.setState({
        currentStep: this.state.currentStep - 1,
        flickerAnimation: "",
      });
    }
  }

  handleStep(index) {
    if (index === 2 || index === 1) {
      this.setState({
        currentStep: index,
        flickerAnimation: "animate-flicker",
      });
    } else {
      this.setState({ currentStep: index, flickerAnimation: "" });
    }
  }

  updateDimensions() {
    // const dpr = window.devicePixelRatio || 1;
    const div = document
      .getElementById("tig_container")
      .getBoundingClientRect();

    const height = window.innerHeight - div.top;
    const width = window.innerWidth - 30;
    const layout = this.layouts[this.state.layoutIndex];
    let scale = Math.min(height / layout.height, width / layout.width);

    if (scale > 1) {
      scale = 1;
    }
    this.setState({
      scaleLayout: scale,
      containerWidth: width,
      containerHeight: height,
    });
  }

  preventScrolling() {
    document.getElementById("mainCanvas").addEventListener(
      "touchmove",
      (e) => {
        // Prevents touch events in the canvas from scrolling the canvas.
        e.preventDefault();
        e.stopPropagation();
      },
      { passive: false }
    );
  }

  uploadToS3(file) {
    //Get File Dimensions

    this.setState({
      uploadStatus: "Uploading your image",
      uploadStatusOpen: true,
    });
    let fr = new FileReader();
    fr.onload = () => {
      let img = new Image();
      img.onload = () => {
        this.newUploadWidth = img.width;
        this.newUploadHeight = img.height;

        if (img.width > img.height) {
          //horz
          this.newUploadZoom =
            this.layouts[this.state.layoutIndex].width / img.width;
        } else {
          //vert
          this.newUploadZoom =
            this.layouts[this.state.layoutIndex].height / img.height;
        }
      };
      img.src = fr.result;
    };
    fr.readAsDataURL(file);

    const filename =
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);

    const config = {
      bucketName: "tig-mls-app-upload",
      dirName: "uploads",
      region: "us-west-2",
      accessKeyId: "AKIAW3RNVPRZ2LBYABH6",
      secretAccessKey: "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",
    };
    const S3Client = new S3(config);
    S3Client.uploadFile(file, filename)
      .then((data) => {
        this.setState({
          uploadStatus: "Image Uploaded. We are processing your image.",
        });
        this.cropImage(data.location);
      })
      .catch((err) => {
        this.setState({
          uploadStatus: "Upload error. Please refresh browser and try again",
          uploadStatusType: "error",
        });
      });
  }

  cropImage(url) {
    const baseUrl =
      "https://xlhogwcmql.execute-api.us-west-2.amazonaws.com/dev/bgrm?url=";

    fetch(baseUrl + url)
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        this.newUploadBg = url;
        this.newUploadTop = data;
        this.newUpload = true;
        this.rerender();
      })
      .catch((err) => {
        this.setState({
          uploadStatus:
            "Processing error. Please refresh browser and try again",
          uploadStatusType: "error",
        });
      });
  }
  handleClickOpen() {
    this.setState({
      dialogOpen: true,
    });
  }

  handleClose() {
    this.setState({
      dialogOpen: false,
    });
  }

  render() {
    return (
      <div>
        <CustomStepper
          activeStep={this.state.currentStep}
          handleNext={this.handleNext.bind(this)}
          handleBack={this.handleBack.bind(this)}
          handleStep={this.handleStep.bind(this)}
        />
        <div style={{ paddingBottom: 20 }}>
          {this.state.currentStep === 0 ? (
            <div className="step1FlexContainer">
              <div>
                <input
                  accept="image/*"
                  id="contained-button-file"
                  multiple
                  type="file"
                  style={{ display: "none" }}
                  onChange={(event) => {
                    if (event.target.files && event.target.files[0]) {
                      this.uploadToS3(event.target.files[0]);
                      this.rerender();
                    }
                  }}
                />
                <label htmlFor="contained-button-file">
                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    style={{ color: "#000" }}
                  >
                    Upload
                  </Button>
                </label>
              </div>
              <div>
                <div style={{ color: "#fff", paddingTop: "10px" }}>
                  Select Theme
                </div>
                <FormControl component="fieldset" style={{ color: "#fff" }}>
                  <RadioGroup
                    row
                    aria-label="theme swap"
                    name="theme swap"
                    value={this.state.theme}
                    onChange={(e) => {
                      this.setState({ theme: e.target.value }, () => {
                        this.themeDirty = true;
                        this.rerender();
                      });
                    }}
                  >
                    <FormControlLabel
                      value="black"
                      control={<Radio color="primary" />}
                      label="Black"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="white"
                      control={<Radio color="primary" />}
                      label="White"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
          ) : (
            ""
          )}
          {this.state.currentStep === 1 ? (
            <div className="step1FlexContainer">
              <div
                style={{
                  paddingLeft: 15,
                  width: 150,
                }}
              >
                <FormControl component="fieldset" style={{ color: "#fff" }}>
                  <RadioGroup
                    row
                    aria-label="position"
                    name="position"
                    value={this.state.playerCutout}
                    onChange={(e) => {
                      if (e.target.value === "true") {
                        this.setState(
                          {
                            playerCutout: e.target.value,
                            bnwExtraLabel: "Background",
                          },
                          () => {
                            this.rerender();
                          }
                        );
                      } else {
                        this.setState(
                          {
                            playerCutout: e.target.value,
                            bnwExtraLabel: "",
                          },
                          () => {
                            this.rerender();
                          }
                        );
                      }
                    }}
                  >
                    <FormControlLabel
                      value="true"
                      control={<Radio color="primary" />}
                      label="Cutout"
                      // labelPlacement="end"
                    />
                    <FormControlLabel
                      value="false"
                      control={<Radio color="primary" />}
                      label="No Cutout"
                      // labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div style={{ width: 140, lineHeight: "1 !important" }}>
                <FormControlLabel
                  style={{ color: "#fff", fontSize: 10 }}
                  control={
                    <Checkbox
                      checked={this.state.bnw}
                      color="primary"
                      onChange={(e) => {
                        this.setState({ bnw: e.target.checked }, () => {
                          this.rerender();
                        });
                      }}
                    />
                  }
                  label={"Black & White " + this.state.bnwExtraLabel}
                />
              </div>
              <div style={{ width: 130, paddingRight: 20 }}>
                <div style={{ color: "#fff" }}>Zoom</div>
                <Slider
                  defaultValue={1}
                  min={0.25}
                  step={0.01}
                  max={2}
                  valueLabelFormat={function valueLabelFormat(value) {
                    return Math.floor(value * 100) + "%";
                  }}
                  onChange={(event, value) => {
                    this.zoom = value;
                    this.rerender();
                  }}
                  onMouseUp={(event, value) => {
                    this.setState(
                      {
                        imgProperties: {
                          ...this.state.imgProperties,
                          scale: value,
                        },
                      },
                      () => {
                        this.rerender();
                      }
                    );
                  }}
                  valueLabelDisplay="auto"
                />
              </div>
            </div>
          ) : (
            ""
          )}
          {this.state.currentStep === 2 ? (
            <div className="step1FlexContainer">
              <TextField
                value={this.state.name}
                label="Name (optional)"
                variant="outlined"
                placeholder="Enter Name"
                style={{ color: "white", marginRight: 20 }}
                onFocus={(e) => {
                  if (this.state.name === "Enter Name") {
                    this.setState({ name: "" }, () => {
                      this.rerender();
                    });
                  }
                }}
                onChange={(e) => {
                  this.setState({ name: e.target.value }, () => {
                    this.rerender();
                  });
                }}
                onBlur={(e) => {
                  if (this.regex.test(this.state.name)) {
                    this.setState(
                      {
                        name: "",
                      },
                      () => {
                        this.rerender();
                      }
                    );
                  }
                }}
              />
              <FormControl variant="outlined">
                <InputLabel id="mls-club">Club</InputLabel>
                <Select
                  style={{ maxWidth: 215 }}
                  native
                  labelId="mls-club"
                  id="mls-club"
                  value={this.state.club}
                  label="Club"
                  onChange={(e) => {
                    this.setState({ club: e.target.value }, () => {
                      if (this.state.club !== "none") {
                        this.clubDirty = true;
                      }
                      this.rerender();
                    });
                  }}
                >
                  {this.clubs}
                </Select>
              </FormControl>
            </div>
          ) : (
            ""
          )}
          {this.state.currentStep === 3 ? (
            <div
              className="step1FlexContainer"
              style={{ justifyContent: "center" }}
            >
              <div style={{ width: 44, height: 44 }}></div>
              <Button
                variant="contained"
                color="primary"
                onClick={(e) => {
                  this.setState(
                    {
                      uploadStatusOpen: true,
                      uploadStatusType: "info",
                      uploadStatus: "Your image is being created",
                    },
                    () => {
                      setTimeout(() => {
                        this.downloadPic = true;
                        this.rerender();
                      }, 500);
                    }
                  );
                }}
              >
                Download
              </Button>

              <IconButton
                color="primary"
                aria-label="help"
                onClick={this.handleClickOpen.bind(this)}
              >
                <HelpIcon />
              </IconButton>
            </div>
          ) : (
            ""
          )}
        </div>
        <div
          id="tig_container"
          className="tig_container"
          style={{
            width: this.state.containerWidth,
            height: this.state.containerHeight,
            overflow: "hidden",
          }}
        >
          <div
            id="tig_main"
            className="tig_main"
            style={{
              width: this.layouts[this.state.layoutIndex].width,
              height: this.layouts[this.state.layoutIndex].height,
              transform:
                "translate(-50%, -50%) scale(" + this.state.scaleLayout + ")",
            }}
          >
            {this.state.flickerAnimation !== "" ? (
              <div
                className={"canvasTopAnimation animate-flicker"}
                onMouseDown={(e) => {
                  this.setState({ flickerAnimation: "" });
                }}
                onTouchStart={(e) => {
                  this.setState({ flickerAnimation: "" });
                }}
              >
                {this.state.currentStep === 2
                  ? "Click Here to adjust banner"
                  : "Click Here to adjust image"}
              </div>
            ) : (
              ""
            )}
            {this.state.loading ? (
              <Card>
                <Skeleton
                  variant="rect"
                  width={this.layouts[this.state.layoutIndex].width}
                  height={this.layouts[this.state.layoutIndex].height}
                />
              </Card>
            ) : (
              <canvas
                id="mainCanvas"
                width={this.layouts[this.state.layoutIndex].width}
                height={this.layouts[this.state.layoutIndex].height}
              />
            )}
          </div>
        </div>
        <Snackbar open={this.state.uploadStatusOpen}>
          <MuiAlert
            elevation={6}
            variant="filled"
            severity={this.state.uploadStatusType}
          >
            {this.state.uploadStatus}
          </MuiAlert>
        </Snackbar>
        <Dialog
          open={this.state.dialogOpen}
          onClose={this.handleClose.bind(this)}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            {"Where to find Image"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              iPhone/iPad: Image will be saved to "Files" app or click view to
              manually save to camera roll.
            </DialogContentText>
            <DialogContentText>
              Android: Image will be saved to "Files" or "File Manager" app
            </DialogContentText>
            <DialogContentText>
              PC & Mac: Image will be saved to your "Downloads" folder
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleClose.bind(this)}
              color="primary"
              autoFocus
            >
              Got it
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withRouter(Layout);
